import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {LanguageService} from '../../services/language.service';

export interface IPost {
    src: string;
    alt: string;
    title: string;
    description: string;
    link: string;
    position: string;
}

@Injectable({
    providedIn: 'root'
})
export class DataService {

    constructor(
        private http: HttpClient,
        private lang: LanguageService
    ) {
    }

    fetchData(): Observable<IPost[]> {
        return this.http.get('https://blog.anima.help/wp-json/wp/v2/posts?_embed&lang=' + this.lang.getCurrentLanguage())
            .pipe(
                map((posts: any[]) => {
                    return posts.map(el => {
                        return {
                            src: el?._embedded['wp:featuredmedia'][0].media_details?.sizes?.full?.source_url,
                            alt: el.acf.frontpage_title,
                            title: el.title.rendered,
                            description: el.description,
                            link: el.link,
                            position: el.acf.frontpage_place
                        };
                    });
                })
            );
    }

    transformUrl(url: string): string {
        return `https://blog.anima.help/wp-content/webp-express/webp-images/uploads/${url.split('/').pop()}.webp`;
    }
}
